import React, { memo } from 'react'
import {
  Container,
  ContainerTexto,
  Titulo,
  Descripcion,
} from './textobellavistastyles'

const BannerAcademy = () => {
  return (
    <Container>
      <ContainerTexto>
        <Titulo>NSTA MONTEQUINTO
</Titulo>
        <Descripcion>
          ¡Bienvenido a  <strong>NSTA MONTEQUINTO</strong>, sumérgete en nuestra vibrante comunidad y disfruta de una Escuela de Tenis que atiende a todos, desde iniciación hasta competición, con programas adaptados a tus necesidades. Vive la emoción de eventos inolvidables, participa en emocionantes torneos y experimenta la intensidad de la competición en ambas disciplinas. Más allá de las pistas, te ofrecemos servicios personalizados y una experiencia integral para que disfrutes al máximo de tu deporte favorito. ¡Te esperamos con entusiasmo!
        </Descripcion>
      </ContainerTexto>
    </Container>
  )
}

export default memo(BannerAcademy)
